const FundTypeTableCss = {
  Oeic: 'oeic-table',
  InvestmentTrust: 'it-table',
};

export default FundTypeTableCss;
